import { Box, Typography } from "@material-ui/core";

const RiskScoreFormula = () => {
  return (
    <Box>
      <Typography variant="h4">Risk Score Formula</Typography>
    </Box>
  );
};

export default RiskScoreFormula;
